import { UseMutationOptions } from "@tanstack/react-query";
import { useMutationApi, useQueryApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models.ts";

import { outgoingPostbackLogApi } from "./api";

import GetOutgoingPostbackLogsResponse = App.Http.Responses.OutgoingPostbackLog.GetOutgoingPostbackLogsResponse;
import GetOutgoingPostbackLogResponse = App.Http.Responses.OutgoingPostbackLog.GetOutgoingPostbackLogResponse;
import GetOutgoingPostbackLogsRequest = App.Http.Requests.OutgoingPostbackLog.GetOutgoingPostbackLogsRequest;
import BaseExportRequest = App.Http.Requests.BaseExportRequest;
import ExportResponse = App.Http.Responses.ExportResponse;

export const useGetOutgoingPostbackLogsQuery = (request: GetOutgoingPostbackLogsRequest, options = {}) => {
    return useQueryApi<GetOutgoingPostbackLogsResponse>({
        queryKey: ["getOutgoingPostbackLogs", request],
        queryFn: () => outgoingPostbackLogApi.index(request),
        ...options,
    });
};

export const useGetOutgoingPostbackLogQuery = (
    logId: string,
    request: { filter?: App.Http.Requests.FilterRequest },
    options = {}
) => {
    return useQueryApi<GetOutgoingPostbackLogResponse>({
        queryKey: ["getOutgoingPostbackLog", logId, request],
        queryFn: () => outgoingPostbackLogApi.show(logId, request),
        ...options,
    });
};

export const useGetOutgoingPostbackLogsExportMutation = (
    options: UseMutationOptions<ExportResponse, AxiosError<ApiErrorResponse>, BaseExportRequest> = {}
) => {
    return useMutationApi<ExportResponse, BaseExportRequest>({
        mutationKey: ["getOutgoingPostbackLogsExport"],
        mutationFn: (request) => outgoingPostbackLogApi.export(request),
        ...options,
    });
};
